import type { ModernSubscription } from '../../types';
import { SubscriptionStates } from '../../types';

export function isActiveTrialWithNoPlan(modernSubscription: ModernSubscription) {
  const { state: subscriptionState } = modernSubscription;
  const state = subscriptionState ?? SubscriptionStates.UNKNOWN;
  return state === SubscriptionStates.ACTIVE_TRIAL;
}
